import { FederatedModule } from '@bfme-technology/spa';
import { getStoredOverrides } from '../../../DeveloperWorkbench/DeveloperWorkbench.utils';



import type { VaultMfeProps } from './VaultMfe.types';

export const VaultMfe: React.FC<VaultMfeProps> = ({ routesLoading, routes }) => {
  const getResolvedMfeProps = (route: any) => {
    const overrides = getStoredOverrides();
    const override = overrides[route.key];

    if (override) {
      return {
        mfeType: route.mfeType,
        elementName: route.elementName,
        bootstrapFnName: route.bootstrapFnName,
        unmountFnName: route.unmountFnName,
        scope: route.scope,
        module: route.module,
        scriptUrl: override.scriptUrl || route.scriptUrl,
        cssUrl: override.cssUrl !== undefined ? override.cssUrl : route.cssUrl,
        mfeProps: route.mfeProps || {},
      };
    }

    return route;
  };

  return (
    <section className="glass-panel p-4 md:p-6 min-h-[300px] flex flex-col">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <div className="w-8 h-8 rounded-full bg-primary-accent/10 flex items-center justify-center shrink-0">
          <i className="fa-solid fa-vault text-primary-accent text-sm" />
        </div>
        <h3 className="text-base md:text-lg font-bold text-text-primary m-0 tracking-wide font-display">
          Active Vault
        </h3>
      </div>
      <div className="grow">
        {(() => {
          if (routesLoading) {
            return (
              <div className="flex items-center justify-center h-full text-text-muted text-sm">
                Loading Vault...
              </div>
            );
          }
          const route = routes.find((r) => r.key === 'mfe-vault');
          if (!route) {
            return (
              <div className="flex items-center justify-center h-full text-red-500 text-sm text-center">
                Vault configuration not found. Check your federatedRoutes.json
              </div>
            );
          }
          const resolved = getResolvedMfeProps(route);
          const { key, ...mfeProps } = resolved;
          return <FederatedModule {...mfeProps} />;
        })()}
      </div>
    </section>
  );
};

export default VaultMfe;
